import { RpcService } from '@holmescorp/rpc';
import { ParentTree } from 'lcc-interfaces';

export interface QuizState {
	content_id: string;
	id: string;
	title: string;
	report_title: string;
	description: string;
	path: string;
	progression: string;
	has_questions: boolean;
	quiz_type: string;
	combined_status: {
		active: boolean;
		complete: boolean;
		passed: boolean;
		status: string;
	};
}

export interface AssessmentChooserSvc extends RpcService {
	get_state(params: { key: 'assessment' }): Promise<ParentTree>;
	pretest_quizzes(params: { site: string; menu?: string }): Promise<{ [key: string]: string }[]>;
	quiz_state(params: { site: string; quizids: string[] }): Promise<{ [key: string]: QuizState }>;
}

export const svc: AssessmentChooserSvc = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@learningpath.rpc`,

	services: {
		get_state: {
			parameters: [
				{
					name: 'key',
					type: 'string',
					optional: false
				}
			]
		},
		pretest_quizzes: {
			parameters: [
				{
					name: 'site',
					type: 'string',
					optional: false
				},
				{
					name: 'menu',
					type: 'string',
					optional: true
				}
			]
		},
		quiz_state: {
			parameters: [
				{
					name: 'site',
					type: 'string',
					optional: false
				},
				{
					name: 'quizids',
					type: 'array',
					optional: false
				}
			]
		}
	}
}) as AssessmentChooserSvc;

export default svc;
